export default {
    props: ["spin"],
    created(){
    }
  };